var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.70711 0.29289C1.31658 -0.09763 0.68342 -0.09763 0.29289 0.29289C-0.09763 0.68342 -0.09763 1.31658 0.29289 1.70711L6.06761 7.48181L0.29295 13.2565C-0.0975699 13.647 -0.0975699 14.2802 0.29295 14.6707C0.68348 15.0612 1.31664 15.0612 1.70716 14.6707L7.48181 8.89601L13.2565 14.6707C13.647 15.0612 14.2802 15.0612 14.6707 14.6707C15.0612 14.2802 15.0612 13.647 14.6707 13.2565L8.89601 7.48181L14.6708 1.70711C15.0613 1.31658 15.0613 0.68342 14.6708 0.29289C14.2803 -0.09763 13.6471 -0.09763 13.2566 0.29289L7.48181 6.06761L1.70711 0.29289Z",
    fill: "#C3C3C3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseGray);
export default __webpack_public_path__ + "static/media/closeGray.d5e75d86dd29d5b8d2a090a2f339beba.svg";
export { ForwardRef as ReactComponent };